import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import { CampaignEntitiesResponseSchema } from '../shared/schemas/campaignEntities.js';

export type {
  CampaignEntityItemType,
  CampaignEntitiesResponseType,
} from '../shared/schemas/campaignEntities.js';

export const getCampaignEntities = defaultClient.query({
  url: 'omni-trafficking/v1/external-data/campaign-entities/' as const,
  method: 'GET',
  responseSchema: CampaignEntitiesResponseSchema,
  processResponse(data) {
    return data?.data?.items;
  },
  querySchema: z.object({
    settingsId: z.string(),
    platformName: z.string(),
    taxonomyItemId: z.string(),
    taxonomyItemExternalId: z.string(),
  }),
  snakeCaseQueryParams: true,
});
